export interface PhoneCountryOption {
  iso2: string;
  flag: string;
  nameAr: string;
  dialCode: string;
  example?: string;
}


const toFlagEmoji = (iso2: string): string =>
  iso2
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));


export const rawPhoneCountries: Omit<PhoneCountryOption, 'flag'>[] = [
  { iso2: 'SA', nameAr: 'المملكة العربية السعودية', dialCode: '+966', example: '5XXXXXXXX' },
  { iso2: 'AE', nameAr: 'الإمارات العربية المتحدة', dialCode: '+971', example: '5XXXXXXXX' },
  { iso2: 'KW', nameAr: 'الكويت', dialCode: '+965', example: 'XXXXXXXX' },
  { iso2: 'QA', nameAr: 'قطر', dialCode: '+974', example: 'XXXXXXXX' },
  { iso2: 'BH', nameAr: 'البحرين', dialCode: '+973', example: 'XXXXXXXX' },
  { iso2: 'OM', nameAr: 'عُمان', dialCode: '+968', example: 'XXXXXXXX' },
  { iso2: 'EG', nameAr: 'مصر', dialCode: '+20', example: '01XXXXXXXXX' },
  { iso2: 'JO', nameAr: 'الأردن', dialCode: '+962', example: '7XXXXXXXX' },
  { iso2: 'US', nameAr: 'الولايات المتحدة', dialCode: '+1', example: 'XXXXXXXXXX' },
  { iso2: 'GB', nameAr: 'المملكة المتحدة', dialCode: '+44', example: '7XXXXXXXXX' },
  { iso2: 'CA', nameAr: 'كندا', dialCode: '+1', example: 'XXXXXXXXXX' },
  { iso2: 'IS', nameAr: 'آيسلندا', dialCode: '+354', example: 'XXXXXXXX' },
  { iso2: 'AZ', nameAr: 'أذربيجان', dialCode: '+994', example: 'XXXXXXXX' },
  { iso2: 'AM', nameAr: 'أرمينيا', dialCode: '+374', example: 'XXXXXXXX' },
  { iso2: 'AW', nameAr: 'أروبا', dialCode: '+297', example: 'XXXXXXXX' },
  { iso2: 'AU', nameAr: 'أستراليا', dialCode: '+61', example: 'XXXXXXXX' },
  { iso2: 'AF', nameAr: 'أفغانستان', dialCode: '+93', example: 'XXXXXXXX' },
  { iso2: 'AL', nameAr: 'ألبانيا', dialCode: '+355', example: 'XXXXXXXX' },
  { iso2: 'DE', nameAr: 'ألمانيا', dialCode: '+49', example: 'XXXXXXXX' },
  { iso2: 'AG', nameAr: 'أنتيغوا وبربودا', dialCode: '+1268', example: 'XXXXXXXX' },
  { iso2: 'AO', nameAr: 'أنغولا', dialCode: '+244', example: 'XXXXXXXX' },
  { iso2: 'AI', nameAr: 'أنغويلا', dialCode: '+1264', example: 'XXXXXXXX' },
  { iso2: 'UY', nameAr: 'أورغواي', dialCode: '+598', example: 'XXXXXXXX' },
  { iso2: 'UZ', nameAr: 'أوزبكستان', dialCode: '+998', example: 'XXXXXXXX' },
  { iso2: 'UG', nameAr: 'أوغندا', dialCode: '+256', example: 'XXXXXXXX' },
  { iso2: 'UA', nameAr: 'أوكرانيا', dialCode: '+380', example: 'XXXXXXXX' },
  { iso2: 'IE', nameAr: 'أيرلندا', dialCode: '+353', example: 'XXXXXXXX' },
  { iso2: 'ET', nameAr: 'إثيوبيا', dialCode: '+251', example: 'XXXXXXXX' },
  { iso2: 'ER', nameAr: 'إريتريا', dialCode: '+291', example: 'XXXXXXXX' },
  { iso2: 'ES', nameAr: 'إسبانيا', dialCode: '+34', example: 'XXXXXXXX' },
  { iso2: 'EE', nameAr: 'إستونيا', dialCode: '+372', example: 'XXXXXXXX' },
  { iso2: 'IL', nameAr: 'إسرائيل', dialCode: '+972', example: 'XXXXXXXX' },
  { iso2: 'SZ', nameAr: 'إسواتيني', dialCode: '+268', example: 'XXXXXXXX' },
  { iso2: 'ID', nameAr: 'إندونيسيا', dialCode: '+62', example: 'XXXXXXXX' },
  { iso2: 'IR', nameAr: 'إيران', dialCode: '+98', example: 'XXXXXXXX' },
  { iso2: 'IT', nameAr: 'إيطاليا', dialCode: '+39', example: 'XXXXXXXX' },
  { iso2: 'AR', nameAr: 'الأرجنتين', dialCode: '+54', example: 'XXXXXXXX' },
  { iso2: 'IO', nameAr: 'الإقليم البريطاني في المحيط الهندي', dialCode: '+246', example: 'XXXXXXXX' },
  { iso2: 'EC', nameAr: 'الإكوادور', dialCode: '+593', example: 'XXXXXXXX' },
  { iso2: 'BR', nameAr: 'البرازيل', dialCode: '+55', example: 'XXXXXXXX' },
  { iso2: 'PT', nameAr: 'البرتغال', dialCode: '+351', example: 'XXXXXXXX' },
  { iso2: 'BA', nameAr: 'البوسنة والهرسك', dialCode: '+387', example: 'XXXXXXXX' },
  { iso2: 'CZ', nameAr: 'التشيك', dialCode: '+420', example: 'XXXXXXXX' },
  { iso2: 'DZ', nameAr: 'الجزائر', dialCode: '+213', example: 'XXXXXXXX' },
  { iso2: 'DK', nameAr: 'الدانمرك', dialCode: '+45', example: 'XXXXXXXX' },
  { iso2: 'CV', nameAr: 'الرأس الأخضر', dialCode: '+238', example: 'XXXXXXXX' },
  { iso2: 'SV', nameAr: 'السلفادور', dialCode: '+503', example: 'XXXXXXXX' },
  { iso2: 'SN', nameAr: 'السنغال', dialCode: '+221', example: 'XXXXXXXX' },
  { iso2: 'SD', nameAr: 'السودان', dialCode: '+249', example: 'XXXXXXXX' },
  { iso2: 'SE', nameAr: 'السويد', dialCode: '+46', example: 'XXXXXXXX' },
  { iso2: 'EH', nameAr: 'الصحراء الغربية', dialCode: '+212', example: 'XXXXXXXX' },
  { iso2: 'SO', nameAr: 'الصومال', dialCode: '+252', example: 'XXXXXXXX' },
  { iso2: 'CN', nameAr: 'الصين', dialCode: '+86', example: 'XXXXXXXX' },
  { iso2: 'IQ', nameAr: 'العراق', dialCode: '+964', example: 'XXXXXXXX' },
  { iso2: 'GA', nameAr: 'الغابون', dialCode: '+241', example: 'XXXXXXXX' },
  { iso2: 'PH', nameAr: 'الفلبين', dialCode: '+63', example: 'XXXXXXXX' },
  { iso2: 'CM', nameAr: 'الكاميرون', dialCode: '+237', example: 'XXXXXXXX' },
  { iso2: 'CG', nameAr: 'الكونغو', dialCode: '+242', example: 'XXXXXXXX' },
  { iso2: 'CD', nameAr: 'الكونغو الديمقراطية', dialCode: '+243', example: 'XXXXXXXX' },
  { iso2: 'MA', nameAr: 'المغرب', dialCode: '+212', example: 'XXXXXXXX' },
  { iso2: 'MX', nameAr: 'المكسيك', dialCode: '+52', example: 'XXXXXXXX' },
  { iso2: 'NO', nameAr: 'النرويج', dialCode: '+47', example: 'XXXXXXXX' },
  { iso2: 'AT', nameAr: 'النمسا', dialCode: '+43', example: 'XXXXXXXX' },
  { iso2: 'NE', nameAr: 'النيجر', dialCode: '+227', example: 'XXXXXXXX' },
  { iso2: 'IN', nameAr: 'الهند', dialCode: '+91', example: 'XXXXXXXX' },
  { iso2: 'JP', nameAr: 'اليابان', dialCode: '+81', example: 'XXXXXXXX' },
  { iso2: 'YE', nameAr: 'اليمن', dialCode: '+967', example: 'XXXXXXXX' },
  { iso2: 'GR', nameAr: 'اليونان', dialCode: '+30', example: 'XXXXXXXX' },
  { iso2: 'PG', nameAr: 'بابوا غينيا الجديدة', dialCode: '+675', example: 'XXXXXXXX' },
  { iso2: 'PY', nameAr: 'باراغواي', dialCode: '+595', example: 'XXXXXXXX' },
  { iso2: 'PK', nameAr: 'باكستان', dialCode: '+92', example: 'XXXXXXXX' },
  { iso2: 'PW', nameAr: 'بالاو', dialCode: '+680', example: 'XXXXXXXX' },
  { iso2: 'BB', nameAr: 'بربادوس', dialCode: '+1246', example: 'XXXXXXXX' },
  { iso2: 'BM', nameAr: 'برمودا', dialCode: '+1441', example: 'XXXXXXXX' },
  { iso2: 'BN', nameAr: 'بروناي', dialCode: '+673', example: 'XXXXXXXX' },
  { iso2: 'BE', nameAr: 'بلجيكا', dialCode: '+32', example: 'XXXXXXXX' },
  { iso2: 'BG', nameAr: 'بلغاريا', dialCode: '+359', example: 'XXXXXXXX' },
  { iso2: 'BZ', nameAr: 'بليز', dialCode: '+501', example: 'XXXXXXXX' },
  { iso2: 'BD', nameAr: 'بنغلاديش', dialCode: '+880', example: 'XXXXXXXX' },
  { iso2: 'PA', nameAr: 'بنما', dialCode: '+507', example: 'XXXXXXXX' },
  { iso2: 'BJ', nameAr: 'بنين', dialCode: '+229', example: 'XXXXXXXX' },
  { iso2: 'BT', nameAr: 'بوتان', dialCode: '+975', example: 'XXXXXXXX' },
  { iso2: 'BW', nameAr: 'بوتسوانا', dialCode: '+267', example: 'XXXXXXXX' },
  { iso2: 'PR', nameAr: 'بورتوريكو', dialCode: '+1787', example: 'XXXXXXXX' },
  { iso2: 'BF', nameAr: 'بوركينا فاسو', dialCode: '+226', example: 'XXXXXXXX' },
  { iso2: 'BI', nameAr: 'بوروندي', dialCode: '+257', example: 'XXXXXXXX' },
  { iso2: 'PL', nameAr: 'بولندا', dialCode: '+48', example: 'XXXXXXXX' },
  { iso2: 'BO', nameAr: 'بوليفيا', dialCode: '+591', example: 'XXXXXXXX' },
  { iso2: 'PF', nameAr: 'بولينيزيا الفرنسية', dialCode: '+689', example: 'XXXXXXXX' },
  { iso2: 'PE', nameAr: 'بيرو', dialCode: '+51', example: 'XXXXXXXX' },
  { iso2: 'BY', nameAr: 'بيلاروس', dialCode: '+375', example: 'XXXXXXXX' },
  { iso2: 'TH', nameAr: 'تايلاند', dialCode: '+66', example: 'XXXXXXXX' },
  { iso2: 'TW', nameAr: 'تايوان', dialCode: '+886', example: 'XXXXXXXX' },
  { iso2: 'TM', nameAr: 'تركمانستان', dialCode: '+993', example: 'XXXXXXXX' },
  { iso2: 'TR', nameAr: 'تركيا', dialCode: '+90', example: 'XXXXXXXX' },
  { iso2: 'TT', nameAr: 'ترينيداد وتوباغو', dialCode: '+1868', example: 'XXXXXXXX' },
  { iso2: 'TD', nameAr: 'تشاد', dialCode: '+235', example: 'XXXXXXXX' },
  { iso2: 'CL', nameAr: 'تشيلي', dialCode: '+56', example: 'XXXXXXXX' },
  { iso2: 'TZ', nameAr: 'تنزانيا', dialCode: '+255', example: 'XXXXXXXX' },
  { iso2: 'TG', nameAr: 'توغو', dialCode: '+228', example: 'XXXXXXXX' },
  { iso2: 'TV', nameAr: 'توفالو', dialCode: '+688', example: 'XXXXXXXX' },
  { iso2: 'TK', nameAr: 'توكيلاو', dialCode: '+690', example: 'XXXXXXXX' },
  { iso2: 'TN', nameAr: 'تونس', dialCode: '+216', example: 'XXXXXXXX' },
  { iso2: 'TO', nameAr: 'تونغا', dialCode: '+676', example: 'XXXXXXXX' },
  { iso2: 'TL', nameAr: 'تيمور الشرقية', dialCode: '+670', example: 'XXXXXXXX' },
  { iso2: 'JM', nameAr: 'جامايكا', dialCode: '+1876', example: 'XXXXXXXX' },
  { iso2: 'GI', nameAr: 'جبل طارق', dialCode: '+350', example: 'XXXXXXXX' },
  { iso2: 'BS', nameAr: 'جزر البهاما', dialCode: '+1242', example: 'XXXXXXXX' },
  { iso2: 'KM', nameAr: 'جزر القمر', dialCode: '+269', example: 'XXXXXXXX' },
  { iso2: 'MQ', nameAr: 'جزر المارتينيك', dialCode: '+596', example: 'XXXXXXXX' },
  { iso2: 'MV', nameAr: 'جزر المالديف', dialCode: '+960', example: 'XXXXXXXX' },
  { iso2: 'PN', nameAr: 'جزر بيتكيرن', dialCode: '+64', example: 'XXXXXXXX' },
  { iso2: 'SB', nameAr: 'جزر سليمان', dialCode: '+677', example: 'XXXXXXXX' },
  { iso2: 'FO', nameAr: 'جزر فارو', dialCode: '+298', example: 'XXXXXXXX' },
  { iso2: 'FK', nameAr: 'جزر فوكلاند', dialCode: '+500', example: 'XXXXXXXX' },
  { iso2: 'KY', nameAr: 'جزر كايمان', dialCode: '+1345', example: 'XXXXXXXX' },
  { iso2: 'CK', nameAr: 'جزر كوك', dialCode: '+682', example: 'XXXXXXXX' },
  { iso2: 'CC', nameAr: 'جزر كوكوس (كيلينغ)', dialCode: '+61', example: 'XXXXXXXX' },
  { iso2: 'MH', nameAr: 'جزر مارشال', dialCode: '+692', example: 'XXXXXXXX' },
  { iso2: 'MP', nameAr: 'جزر ماريانا الشمالية', dialCode: '+1670', example: 'XXXXXXXX' },
  { iso2: 'WF', nameAr: 'جزر والس وفوتونا', dialCode: '+681', example: 'XXXXXXXX' },
  { iso2: 'CX', nameAr: 'جزيرة كريسماس', dialCode: '+61', example: 'XXXXXXXX' },
  { iso2: 'IM', nameAr: 'جزيرة مان', dialCode: '+44', example: 'XXXXXXXX' },
  { iso2: 'NF', nameAr: 'جزيرة نورفولك', dialCode: '+672', example: 'XXXXXXXX' },
  { iso2: 'CF', nameAr: 'جمهورية أفريقيا الوسطى', dialCode: '+236', example: 'XXXXXXXX' },
  { iso2: 'DO', nameAr: 'جمهورية الدومينيكان', dialCode: '+1809', example: 'XXXXXXXX' },
  { iso2: 'ZA', nameAr: 'جنوب أفريقيا', dialCode: '+27', example: 'XXXXXXXX' },
  { iso2: 'SS', nameAr: 'جنوب السودان', dialCode: '+211', example: 'XXXXXXXX' },
  { iso2: 'GE', nameAr: 'جورجيا', dialCode: '+995', example: 'XXXXXXXX' },
  { iso2: 'GS', nameAr: 'جورجيا الجنوبية وجزر ساندويتش الجنوبية', dialCode: '+500', example: 'XXXXXXXX' },
  { iso2: 'DJ', nameAr: 'جيبوتي', dialCode: '+253', example: 'XXXXXXXX' },
  { iso2: 'JE', nameAr: 'جيرزي', dialCode: '+44', example: 'XXXXXXXX' },
  { iso2: 'DM', nameAr: 'دومينيكا', dialCode: '+1767', example: 'XXXXXXXX' },
  { iso2: 'RW', nameAr: 'رواندا', dialCode: '+250', example: 'XXXXXXXX' },
  { iso2: 'RU', nameAr: 'روسيا', dialCode: '+7', example: 'XXXXXXXX' },
  { iso2: 'RO', nameAr: 'رومانيا', dialCode: '+40', example: 'XXXXXXXX' },
  { iso2: 'RE', nameAr: 'ريونيون', dialCode: '+262', example: 'XXXXXXXX' },
  { iso2: 'ZM', nameAr: 'زامبيا', dialCode: '+260', example: 'XXXXXXXX' },
  { iso2: 'ZW', nameAr: 'زيمبابوي', dialCode: '+263', example: 'XXXXXXXX' },
  { iso2: 'CI', nameAr: 'ساحل العاج', dialCode: '+225', example: 'XXXXXXXX' },
  { iso2: 'WS', nameAr: 'ساموا', dialCode: '+685', example: 'XXXXXXXX' },
  { iso2: 'AS', nameAr: 'ساموا الأمريكية', dialCode: '+1684', example: 'XXXXXXXX' },
  { iso2: 'PM', nameAr: 'سان بيير ومكويلون', dialCode: '+508', example: 'XXXXXXXX' },
  { iso2: 'SM', nameAr: 'سان مارينو', dialCode: '+378', example: 'XXXXXXXX' },
  { iso2: 'VC', nameAr: 'سانت فينسنت والغرينادين', dialCode: '+1784', example: 'XXXXXXXX' },
  { iso2: 'KN', nameAr: 'سانت كيتس ونيفيس', dialCode: '+1869', example: 'XXXXXXXX' },
  { iso2: 'LC', nameAr: 'سانت لوسيا', dialCode: '+1758', example: 'XXXXXXXX' },
  { iso2: 'SH', nameAr: 'سانت هيلينا', dialCode: '+290', example: 'XXXXXXXX' },
  { iso2: 'ST', nameAr: 'ساو تومي وبرينسيبي', dialCode: '+239', example: 'XXXXXXXX' },
  { iso2: 'LK', nameAr: 'سريلانكا', dialCode: '+94', example: 'XXXXXXXX' },
  { iso2: 'SJ', nameAr: 'سفالبارد وجان ماين', dialCode: '+4779', example: 'XXXXXXXX' },
  { iso2: 'SK', nameAr: 'سلوفاكيا', dialCode: '+421', example: 'XXXXXXXX' },
  { iso2: 'SI', nameAr: 'سلوفينيا', dialCode: '+386', example: 'XXXXXXXX' },
  { iso2: 'SG', nameAr: 'سنغافورة', dialCode: '+65', example: 'XXXXXXXX' },
  { iso2: 'SY', nameAr: 'سوريا', dialCode: '+963', example: 'XXXXXXXX' },
  { iso2: 'SR', nameAr: 'سورينام', dialCode: '+597', example: 'XXXXXXXX' },
  { iso2: 'CH', nameAr: 'سويسرا', dialCode: '+41', example: 'XXXXXXXX' },
  { iso2: 'SL', nameAr: 'سيراليون', dialCode: '+232', example: 'XXXXXXXX' },
  { iso2: 'SC', nameAr: 'سيشل', dialCode: '+248', example: 'XXXXXXXX' },
  { iso2: 'RS', nameAr: 'صربيا', dialCode: '+381', example: 'XXXXXXXX' },
  { iso2: 'TJ', nameAr: 'طاجيكستان', dialCode: '+992', example: 'XXXXXXXX' },
  { iso2: 'GM', nameAr: 'غامبيا', dialCode: '+220', example: 'XXXXXXXX' },
  { iso2: 'GH', nameAr: 'غانا', dialCode: '+233', example: 'XXXXXXXX' },
  { iso2: 'GD', nameAr: 'غرينادا', dialCode: '+1473', example: 'XXXXXXXX' },
  { iso2: 'GL', nameAr: 'غرينلاند', dialCode: '+299', example: 'XXXXXXXX' },
  { iso2: 'GT', nameAr: 'غواتيمالا', dialCode: '+502', example: 'XXXXXXXX' },
  { iso2: 'GP', nameAr: 'غوادلوب', dialCode: '+590', example: 'XXXXXXXX' },
  { iso2: 'GU', nameAr: 'غوام', dialCode: '+1671', example: 'XXXXXXXX' },
  { iso2: 'GF', nameAr: 'غويانا الفرنسية', dialCode: '+594', example: 'XXXXXXXX' },
  { iso2: 'GY', nameAr: 'غيانا', dialCode: '+592', example: 'XXXXXXXX' },
  { iso2: 'GG', nameAr: 'غيرنزي', dialCode: '+44', example: 'XXXXXXXX' },
  { iso2: 'GN', nameAr: 'غينيا', dialCode: '+224', example: 'XXXXXXXX' },
  { iso2: 'GQ', nameAr: 'غينيا الاستوائية', dialCode: '+240', example: 'XXXXXXXX' },
  { iso2: 'GW', nameAr: 'غينيا بيساو', dialCode: '+245', example: 'XXXXXXXX' },
  { iso2: 'VU', nameAr: 'فانواتو', dialCode: '+678', example: 'XXXXXXXX' },
  { iso2: 'FR', nameAr: 'فرنسا', dialCode: '+33', example: 'XXXXXXXX' },
  { iso2: 'VE', nameAr: 'فنزويلا', dialCode: '+58', example: 'XXXXXXXX' },
  { iso2: 'FI', nameAr: 'فنلندا', dialCode: '+358', example: 'XXXXXXXX' },
  { iso2: 'VN', nameAr: 'فيتنام', dialCode: '+84', example: 'XXXXXXXX' },
  { iso2: 'FJ', nameAr: 'فيجي', dialCode: '+679', example: 'XXXXXXXX' },
  { iso2: 'CY', nameAr: 'قبرص', dialCode: '+357', example: 'XXXXXXXX' },
  { iso2: 'KG', nameAr: 'قيرغيزستان', dialCode: '+996', example: 'XXXXXXXX' },
  { iso2: 'KZ', nameAr: 'كازاخستان', dialCode: '+76', example: 'XXXXXXXX' },
  { iso2: 'NC', nameAr: 'كاليدونيا الجديدة', dialCode: '+687', example: 'XXXXXXXX' },
  { iso2: 'HR', nameAr: 'كرواتيا', dialCode: '+385', example: 'XXXXXXXX' },
  { iso2: 'KH', nameAr: 'كمبوديا', dialCode: '+855', example: 'XXXXXXXX' },
  { iso2: 'CU', nameAr: 'كوبا', dialCode: '+53', example: 'XXXXXXXX' },
  { iso2: 'KR', nameAr: 'كوريا الجنوبية', dialCode: '+82', example: 'XXXXXXXX' },
  { iso2: 'KP', nameAr: 'كوريا الشمالية', dialCode: '+850', example: 'XXXXXXXX' },
  { iso2: 'CR', nameAr: 'كوستاريكا', dialCode: '+506', example: 'XXXXXXXX' },
  { iso2: 'CO', nameAr: 'كولومبيا', dialCode: '+57', example: 'XXXXXXXX' },
  { iso2: 'KI', nameAr: 'كيريباتي', dialCode: '+686', example: 'XXXXXXXX' },
  { iso2: 'KE', nameAr: 'كينيا', dialCode: '+254', example: 'XXXXXXXX' },
  { iso2: 'LV', nameAr: 'لاتفيا', dialCode: '+371', example: 'XXXXXXXX' },
  { iso2: 'LA', nameAr: 'لاوس', dialCode: '+856', example: 'XXXXXXXX' },
  { iso2: 'LB', nameAr: 'لبنان', dialCode: '+961', example: 'XXXXXXXX' },
  { iso2: 'LU', nameAr: 'لوكسمبورغ', dialCode: '+352', example: 'XXXXXXXX' },
  { iso2: 'LY', nameAr: 'ليبيا', dialCode: '+218', example: 'XXXXXXXX' },
  { iso2: 'LR', nameAr: 'ليبيريا', dialCode: '+231', example: 'XXXXXXXX' },
  { iso2: 'LT', nameAr: 'ليتوانيا', dialCode: '+370', example: 'XXXXXXXX' },
  { iso2: 'LI', nameAr: 'ليختنشتاين', dialCode: '+423', example: 'XXXXXXXX' },
  { iso2: 'LS', nameAr: 'ليسوتو', dialCode: '+266', example: 'XXXXXXXX' },
  { iso2: 'MT', nameAr: 'مالطا', dialCode: '+356', example: 'XXXXXXXX' },
  { iso2: 'ML', nameAr: 'مالي', dialCode: '+223', example: 'XXXXXXXX' },
  { iso2: 'MY', nameAr: 'ماليزيا', dialCode: '+60', example: 'XXXXXXXX' },
  { iso2: 'YT', nameAr: 'مايوت', dialCode: '+262', example: 'XXXXXXXX' },
  { iso2: 'MG', nameAr: 'مدغشقر', dialCode: '+261', example: 'XXXXXXXX' },
  { iso2: 'MK', nameAr: 'مقدونيا الشمالية', dialCode: '+389', example: 'XXXXXXXX' },
  { iso2: 'MW', nameAr: 'ملاوي', dialCode: '+265', example: 'XXXXXXXX' },
  { iso2: 'MO', nameAr: 'ماكاو', dialCode: '+853', example: 'XXXXXXXX' },
  { iso2: 'MN', nameAr: 'منغوليا', dialCode: '+976', example: 'XXXXXXXX' },
  { iso2: 'MR', nameAr: 'موريتانيا', dialCode: '+222', example: 'XXXXXXXX' },
  { iso2: 'MU', nameAr: 'موريشيوس', dialCode: '+230', example: 'XXXXXXXX' },
  { iso2: 'MZ', nameAr: 'موزمبيق', dialCode: '+258', example: 'XXXXXXXX' },
  { iso2: 'MD', nameAr: 'مولدوفا', dialCode: '+373', example: 'XXXXXXXX' },
  { iso2: 'MC', nameAr: 'موناكو', dialCode: '+377', example: 'XXXXXXXX' },
  { iso2: 'MS', nameAr: 'مونتسرات', dialCode: '+1664', example: 'XXXXXXXX' },
  { iso2: 'FM', nameAr: 'ميكرونيزيا', dialCode: '+691', example: 'XXXXXXXX' },
  { iso2: 'NA', nameAr: 'ناميبيا', dialCode: '+264', example: 'XXXXXXXX' },
  { iso2: 'NR', nameAr: 'ناورو', dialCode: '+674', example: 'XXXXXXXX' },
  { iso2: 'NP', nameAr: 'نيبال', dialCode: '+977', example: 'XXXXXXXX' },
  { iso2: 'NG', nameAr: 'نيجيريا', dialCode: '+234', example: 'XXXXXXXX' },
  { iso2: 'NI', nameAr: 'نيكاراغوا', dialCode: '+505', example: 'XXXXXXXX' },
  { iso2: 'NZ', nameAr: 'نيوزيلندا', dialCode: '+64', example: 'XXXXXXXX' },
  { iso2: 'NU', nameAr: 'نيوي', dialCode: '+683', example: 'XXXXXXXX' },
  { iso2: 'HT', nameAr: 'هايتي', dialCode: '+509', example: 'XXXXXXXX' },
  { iso2: 'HN', nameAr: 'هندوراس', dialCode: '+504', example: 'XXXXXXXX' },
  { iso2: 'HU', nameAr: 'هنغاريا', dialCode: '+36', example: 'XXXXXXXX' },
  { iso2: 'NL', nameAr: 'هولندا', dialCode: '+31', example: 'XXXXXXXX' },
  { iso2: 'HK', nameAr: 'هونغ كونغ', dialCode: '+852', example: 'XXXXXXXX' },
];

export const phoneCountries: PhoneCountryOption[] = rawPhoneCountries.map((country) => ({
  ...country,
  flag: toFlagEmoji(country.iso2),
}));

const phoneCountryByIso2 = new Map(phoneCountries.map((country) => [country.iso2, country]));

export const getPhoneCountryByIso2 = (iso2?: string | null): PhoneCountryOption | undefined => {
  if (!iso2) {
    return undefined;
  }

  return phoneCountryByIso2.get(iso2.trim().toUpperCase());
};

export const getPhoneCountryLabel = (iso2?: string | null): string => {
  const country = getPhoneCountryByIso2(iso2);
  if (!country) {
    return '';
  }

  return `${country.flag} ${country.nameAr}`;
};
